import { CommonHttp } from "@/models/interfaces/http/common.http.request";
import {WorkerListItem} from "@/store/jobs";
import { CommonWorkerHolder } from "@/models/interfaces/workers/worker-models";
import { CommonEntityRecord } from "@/models/interfaces/common";


export type AttachedWorker = {
    Id: number,
    Name: string,
    Removed: boolean,
    Roles: CommonEntityRecord[]
}

export class WorkerApi {
    // Получение профиля текущего пользователя
    static getWorkerProfile(): Promise<Worker> {
        const http = new CommonHttp()
        return http
            .get('workers/worker/profile')
            .then(data => data.data)
    }
    // Получение пользователей/департаментов, исключая удаленных и заблокированных
    static getWorkerAndDepartmentsList(): Promise<WorkerListItem[]> {
        const http = new CommonHttp()
        return http
            .get('workers/departments')
            .then(data => data.data)
    }

    // Получение списка сотрудников для присоединения к клиенту
    static getAttachWorkersList(clientId: number): Promise<CommonWorkerHolder[]> {
        const http = new CommonHttp()
        return http
            .get(`workers/client/${clientId}/attach/workers`)
            .then(data => data.data)
    }

    // Присоединение сотрудника к клиенту
    static attachWorker(entityId: number, workerId: number): Promise<AttachedWorker[]> {
        const http = new CommonHttp()
        return http
            .put(`workers/client/attach`, { entityId, workerId })
            .then(data => data.data)
    }

    // Отсоединение сотрудника от клиента
    static detachWorker(entityId: number, workerId: number): Promise<AttachedWorker[]> {
        const http = new CommonHttp()
        return http
            .put(`workers/client/detach`, { entityId, workerId })
            .then(data => data.data)
    }

    // Получение списка ролей, доступных для присоединения сотруднику у клиента
    static getWorkerRoles(entityId: number, workerId: number): Promise<CommonEntityRecord[]> {
        const http = new CommonHttp()
        return http
            .get(`workers/client/roles?entityId=${entityId}&workerId=${workerId}`)
            .then(data => data.data)
    }

    // Присоединение роли сотруднику у клиента
    static attachRole(workerId: number, entityId: number, roleId: number): Promise<void> {
        const http = new CommonHttp()
        return http
            .put(`workers/client/role/attach`, { WorkerId: workerId, EntityId: entityId, RoleId: roleId })
            .then(() => undefined)
    }

    // Отсоединение роли у сотрудника у клиента
    static detachRole(workerId: number, entityId: number, roleId: number): Promise<void> {
        const http = new CommonHttp()
        return http
            .put(`workers/client/role/dettach`, { WorkerId: workerId, EntityId: entityId, RoleId: roleId })
            .then(() => undefined)
    }

    // Установка статуса текущего сотрудника
    static setStatus(value: string): Promise<void> {
        const http = new CommonHttp()
        return http
            .patch(`workers/status`, { value })
            .then(() => undefined)
    }
}

export type Worker = {
    Id: number,
    Name: string,
    Username: string,
    IsAdmin: boolean,
    Mail: string,
    FilePath: string,
    MessageSendingWay: number,
    PhotoLink: string,
    PhotoLiter: string,
    Language: number,
    Status: string,
    AnalyticsAccess: boolean,
    CalendarAccess: boolean,
    StorageAccess: number,
    IsBooker: boolean
}
